import { render, staticRenderFns } from "./MainNav.vue?vue&type=template&id=df5f261e&scoped=true&"
import script from "./MainNav.vue?vue&type=script&lang=ts&"
export * from "./MainNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5f261e",
  null
  
)

export default component.exports